export enum EProductStatus {
  InActive = 0,
  Active = 1,
  All = 2,
}
